<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row>
      <b-col xl="9" lg="10" class="mx-auto">
        <b-row class="mt-md-4 mt-1">
          <b-col xl="2" lg="1" offset-lg="0" md="2" offset-md="1" class="text-center px-0  ">
            <img class="imageTitleDY" src="@/assets/images/doom-yoga/doomyoga-music.png" alt="doomyoga Logo" />
          </b-col>
          <b-col xl="10" lg="11" md="8" class="d-flex align-items-center text-center">
            <h2 class="welcomeUserHomeH2DY mb-0 ">Surrender to Sound and Silence</h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <MediaSimpleCardListSpotify v-if="spotify_playlists.length > 0" list_title="Playlists" :list_items="spotify_playlists" type="music_spotify" />
    <MediaSimpleCardList v-if="mp3_playlists.length > 0" list_title="Exclusive Music" :list_items="mp3_playlists"
      type="music_mp3" />
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import MediaSimpleCardListSpotify from "@/components/media_components/MediaSimpleCardListSpotify.vue";
import axios from "axios";

import Spotify from "spotify-web-api-node";
var ServerMethods = require("spotify-web-api-node/src/server-methods");
Spotify._addMethods(ServerMethods);

import { getSpotifyToken, getSpotifyAccessToken } from "@/utils/spotify-functions.js"


export default {
  name: "DoOmYogaCustomerMusic",
  components: { MediaSimpleCardList, MediaSimpleCardListSpotify },
  data() {
    return {
      client_name_to:"doom_yoga",

      login_user: window.localStorage.getItem("user"),
      user_name: "",
      media_library: "music_library",

      spotify_playlists: [
      ],
      mp3_playlists: [
      ],
    };
  },
  mounted() {
    this.getSpotifyToken('DY', 'customer')
    this.spotifyApi = new Spotify();
    this.spotifyApi.setAccessToken(
      localStorage.getItem("spotify_access_token")
    );

    this.getMp3Playlists()
    this.getSpotifyPlaylists()
  },
  methods: {
    getSpotifyToken, getSpotifyAccessToken,
    getSpotifyPlaylists() {
      axios
        .get("social/admin/playlists", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.spotify_playlists = response.data.data;
        });
    },
    getMp3Playlists() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.mp3_playlists = response.data;
          // this.category_list_select = response.data.slice(0);

          // this.category_list_select.push({ title: "New category", id: "new" })
        });
    },
  }
};
</script>

<style scoped::v-deep ></style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Music/Index.vue